<div class="rmd-age-date-outer-container">
    <div class="rmd-title">{{title}}</div>
    <div class="rmd-age-date-container">
        <div class="rmd-age-date">{{date}}</div>
    </div>
</div>